/**
 * Data Fetch Type Constants
 * Defines all available data fetching strategies
 */

export enum DataFetchType {
  None = '',
  API = 'api',
  ValueList = 'valuelist',
  Patch = 'patch',
  APInPatch = 'apinpatch',
  DBQuery = 'dbquery',
  JSExecutor = 'jsexecutor',
}

/**
 * Human-readable descriptions for each data fetch type
 */
export const DATA_FETCH_DESCRIPTIONS: Record<string, string> = {
  [DataFetchType.None]: 'No data fetching',
  [DataFetchType.API]: 'Fetch from API endpoint',
  [DataFetchType.ValueList]: 'Load from value list',
  [DataFetchType.Patch]: 'Copy from another field',
  [DataFetchType.APInPatch]: 'Fetch from API and patch first result',
  [DataFetchType.DBQuery]: 'Execute database query',
  [DataFetchType.JSExecutor]: 'Execute JavaScript code for calculated fields',
};

/**
 * Data fetch types that require an endpoint/URL
 */
export const ENDPOINT_REQUIRED_TYPES = [
  DataFetchType.API,
  DataFetchType.APInPatch,
  DataFetchType.DBQuery,
];

/**
 * Data fetch types that work with other fields
 */
export const FIELD_DEPENDENT_TYPES = [
  DataFetchType.Patch,
  DataFetchType.APInPatch,
  DataFetchType.JSExecutor,
];

/**
 * Data fetch types that support real-time calculation
 */
export const REALTIME_CALCULATION_TYPES = [
  DataFetchType.JSExecutor,
  DataFetchType.Patch,
];
